import * as React from 'react';

import { Svg } from 'src/styledComponents/Icons';

export const SportIcon: React.FC<{ link?: string }> = (props) => {
  if (!props.link) return <Svg className='sport-type' name='NoSportType' size={24} />;

  return <img className='sport-type' src={props.link} alt='alt-image' />;
};
